// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2ZKok","footer":"ModalError_footer__3w3F1"};